import { render, staticRenderFns } from "./DocRecord.vue?vue&type=template&id=16d97218&scoped=true&"
import script from "./DocRecord.vue?vue&type=script&lang=js&"
export * from "./DocRecord.vue?vue&type=script&lang=js&"
import style0 from "./DocRecord.vue?vue&type=style&index=0&id=16d97218&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d97218",
  null
  
)

export default component.exports